import React, { useState } from 'react'
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import valueone from "../../assets/img/values-1.png";
import valuetwo from "../../assets/img/values-2.png";
import valuethree from "../../assets/img/values-3.png";
import { Card } from 'react-bootstrap';
import dummyimage from '../../assets/img/dummyimage.svg';
import protection from '../../assets/img/protection.png';
import { MdOutlinePrivacyTip } from 'react-icons/md';
import { AiOutlineStar } from 'react-icons/ai';
import taskdeapp from '../../assets/img/taskde-app.png';
import appstore from '../../assets/img/app-store.png';
import playstore from '../../assets/img/google-play.png';

const HowItWorks = () => {

    const [isOpen, setOpen] = useState(false);

    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>How It Works </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name">How it works</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="LXb3EKWsInQ" onClose={() => setOpen(false)} />
            <section className="post-task p-5" data-aos="fade-up" data-aos-duration="2000">
                <header className="section-header">
                    <p className="two">The best place for people and businesses to outsource tasks</p>
                </header>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <button aria-current="page" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center active" onClick={() => setOpen(true)} href="/">
                                    <i className="bi bi-play"></i> <span>See how it works </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="values" className="values" data-aos="fade-up" data-aos-duration="2000">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="box">
                                <img src={valueone} className="img-fluid" alt="" />
                                <h3>What do you need done?</h3>
                                <p>Start by telling us about your task. Mention when and where (in person or online) you need it done, then suggest a fair budget for the task. Post any task you need from cleaning to web design in only two minutes – for free! There's no obligation to hire.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mt-4 mt-lg-0">
                            <div className="box">
                                <img src={valuetwo} className="img-fluid" alt="" />
                                <h3>Choose the best person for you</h3>
                                <p>Take a look at profiles and reviews to pick the best Tasker for your task. When you accept an offer, your payment is held securely with Airtasker Pay until the task is complete. Now you can message and call the Tasker to sort out the details.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 mt-4 mt-lg-0">
                            <div className="box">
                                <img src={valuethree} className="img-fluid" alt="" />
                                <h3>Task completed</h3>
                                <p>With your task complete, you just need to release the payment held with Airtasker Pay. Then you’re free to leave a review for the Tasker so everyone can know what a great job they’ve done!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="feature" className="feature">
                <div className="container">

                    <ul className="nav nav-tabs row gy-4 d-flex">

                        <li className="nav-item col-6 col-md-4 col-lg-2">
                            <Link className="nav-link active show" data-bs-toggle="tab" data-bs-target="#tab-1">
                                <h4>Post your task</h4>
                            </Link>
                        </li>

                        <li className="nav-item col-6 col-md-4 col-lg-2">
                            <Link className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-2">
                                <h4>Customer support</h4>
                            </Link>
                        </li>

                        <li className="nav-item col-6 col-md-4 col-lg-2">
                            <Link className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-3">
                                <h4>Rating & reviews</h4>
                            </Link>
                        </li>

                        <li className="nav-item col-6 col-md-4 col-lg-2">
                            <Link className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-4">
                                <h4>Communication</h4>
                            </Link>
                        </li>

                        <li className="nav-item col-6 col-md-4 col-lg-2">
                            <Link className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-5">
                                <h4>Taskde pay</h4>
                            </Link>
                        </li>

                        <li className="nav-item col-6 col-md-4 col-lg-2">
                            <Link className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-6">
                                <h4>Apps</h4>
                            </Link>
                        </li>

                    </ul>

                    <div className="tab-content">

                        <div className="tab-pane active show" id="tab-1">
                            <div className="row gy-4">
                                <div className="col-lg-12 order-2 order-lg-1">
                                    <h3>Post your task</h3>
                                    <p>
                                        Want your home cleaned or furniture put together? Just tell us about the task you’d like done, suggest a fair budget for a job well done and you’ll start to receive offers from available Taskers.
                                    </p>
                                    <div className='row'>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className='row mt-4'>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                        <div className='col-lg-3'>
                                            <Link className='' to=''>
                                                <Card>
                                                    <Card.Img variant="top" src={dummyimage} />
                                                    <Card.Body>
                                                        <Card.Title>Lorem Ipsum</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane" id="tab-2">
                            <div className="row gy-4">
                                <div className="col-lg-12 order-2 order-lg-1">

                                    <section className='protection'>
                                        <div className='container'>
                                            <div className='row'>
                                                <div className='col-lg-4 col-md-5 col-sm-12 col-12'>
                                                    <div className='protection-desc mt-5'>
                                                        <div className='protection-desc-input'>
                                                            <MdOutlinePrivacyTip fill='#264796' style={{ width: '24px', height: '24px' }} />
                                                            <h3 className='ms-2'>Public Liability*</h3>
                                                        </div>
                                                        <div>Taskde Insurance covers the Tasker for their liability to third parties for personal injury or property damage whilst performing certain task activities</div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-4 col-md-7 col-sm-12 col-12'>
                                                    <div className='protection-img'>
                                                        <img src={protection} className='img-fluid' alt='' />
                                                    </div>
                                                    <div className='protection-btn text-center'>
                                                        <Link className="becometasker scrollto" to="/">Learn more</Link>
                                                    </div>
                                                </div>
                                                <div className='col-lg-4 col-md-5 col-sm-12 col-12'>
                                                    <div className='protection-desc mt-5'>
                                                        <div className='protection-desc-input'>
                                                            <AiOutlineStar fill='#264796' style={{ width: '24px', height: '24px' }} />
                                                            <h3 className='ms-2'>Top rated insurance</h3>
                                                        </div>
                                                        <div>Taskde Insurance is provided by Berkshire Hathaway Specialty Insurance - one of the most reputable and innovative insurance brands</div>
                                                        <div className='protection-terms'>
                                                            <div>*subject to terms and conditions, excess and exclusions applies.</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane" id="tab-3">
                            <div className="row gy-4">
                                <div className="col-lg-12 order-2 order-lg-1">
                                    <h3>Pariatur</h3>
                                    <div>
                                        Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                        culpa qui officia deserunt mollit anim id est laborum
                                    </div>
                                    <ul>
                                        <li><i className="bi bi-check-circle-fill"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Provident mollitia neque rerum asperiores dolores quos qui a. Ipsum neque dolor voluptate nisi sed.</li>
                                    </ul>
                                    <p className="fst-italic">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane" id="tab-4">
                            <div className="row gy-4">
                                <div className="col-lg-12 order-2 order-lg-1">
                                    <h3>Nostrum</h3>
                                    <div>
                                        Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                        culpa qui officia deserunt mollit anim id est laborum
                                    </div>
                                    <p className="fst-italic">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua.
                                    </p>
                                    <ul>
                                        <li><i className="bi bi-check-circle-fill"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane" id="tab-5">
                            <div className="row gy-4">
                                <div className="col-lg-12 order-2 order-lg-1">
                                    <h3>Adipiscing</h3>
                                    <div>
                                        Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                        culpa qui officia deserunt mollit anim id est laborum
                                    </div>
                                    <p className="fst-italic">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                                        magna aliqua.
                                    </p>
                                    <ul>
                                        <li><i className="bi bi-check-circle-fill"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                                        <li><i className="bi bi-check-circle-fill"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane" id="tab-6">
                            <div className="row gy-4">
                                <div className="col-lg-6 order-2 order-lg-1">
                                    <div className="content">
                                        <div className="container-inner mt-5">
                                            <div className="list column-2 text-description">
                                                <h3 className="blue">On the move?</h3>
                                                <p>Download the Taskde App and get the tasks you need completed with just a tap of the button. You can also browse available tasks and earn money wherever you go!</p>

                                            </div>
                                            <div className="list column-2 smart-phones">
                                                <img alt="" src={appstore} className='img-fluid' />
                                                <img alt="" src={playstore} className='img-fluid' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className="apps-badges">
                                        <Link to="https://itunes.apple.com/au/app/airtasker/id512137061?mt=8">
                                            <img alt="" src={taskdeapp} className='img-fluid' />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <Footer />


            {/* <section className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li>How It Works</li>
                    </ol>
                    <h2>How It Works</h2>
                </div>
            </section> */}
        </React.Fragment>
    )
}

export default HowItWorks;